import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { AxiosResponse } from 'axios';
import { token } from '../globals';
import { Json } from '../types';
import { parseData } from './object';

type Method = 'get' | 'post' | 'put' | 'delete' | 'patch';

export type Response = {
  isSuccess: boolean;
  isError: boolean;
  data: Json[];
  error: string;
};

export class Axios {
  private instance: AxiosInstance;

  constructor(public baseUrl: string) {
    this.instance = axios.create({
      baseURL: baseUrl,
    });
  }

  run(
    method: Method,
    path: string,
    data: Json | string = {},
    isAnonymous?: boolean
  ): Promise<Response> {
    return new Promise((resolve) => {
      const output: Response = {
        isSuccess: true,
        isError: false,
        data: [],
        error: '',
      };

      const headers: any = {};

      const config: AxiosRequestConfig = {
        method: method.toUpperCase(),
        url: path,
      };

      if (!isAnonymous) {
        headers.Authorization = `Bearer ${token}`;
        headers.contentType = 'application/json';
      }

      if (data instanceof FormData) {
        headers['Content-Type'] = 'multipart/form-data';
        config.timeout = 100 * 60 * 1000;
      }

      config.headers = headers;

      if (data) {
        if (method === 'get') {
          config.params = data;
        } else {
          config.data = data;
        }
      }

      return this.instance(config)
        .then((response) => {
          output.isSuccess = true;
          output.data = parseData(response.data);
          resolve(output);
        })
        .catch((error) => {
          output.isSuccess = false;
          output.isError = true;
          output.error = error.message;
          resolve(output);
        });
    });
  }

  internalApi(path: string, iModel: IModel): Promise<AxiosResponse<ArrayBuffer>> {
    const payload = {
      imodel: iModel,
    };
    return this.instance.post(this.baseUrl + path, payload);
  }

  blob(path: string) {
    return this.instance.get(path, { responseType: 'blob' });
  }
}
